import type { ReactNode } from 'react';

export const WidgetContainer = ({
  children,
  title,
  action,
}: {
  children: ReactNode;
  title: string;
  action?: ReactNode;
}) => {
  return (
    // A card takes the width of its dashboard grid column and gives that width
    // to what it holds: @container lets the summary tiles and the chart size
    // off the card rather than the viewport, so the same card works three-up on
    // a laptop and one-up on a phone.
    //
    // No h-fit: the grid stretches every card on a row to the tallest, and
    // flex-col lets a short one hand that slack to a chart with no height of
    // its own, rather than leaving white space under it.
    <div className="@container flex flex-col lg:overflow-hidden rounded-lg bg-white p-4 shadow-sm overflow-y-auto">
      <div className="flex shrink-0 items-start justify-between gap-2">
        <dt className="truncate text-xl font-bold text-gray-700">{title}</dt>
        {action}
      </div>
      {children}
    </div>
  );
};
